module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Balloon-5bd00bd5a69e324a6174c1b4313a4d02.png";